import React from 'react';
import PropTypes from 'prop-types';

import Date from "components/Display/ViewDate";
import Amount from "components/Display/Amount";
import Percentage from "components/Display/Percentage";
import YesNo from "components/Display/YesNo";

import Checkbox from "jsx/elements/inputs/Checkbox";
import TransactionKey from "../Display/TransactionKey";
import CostCalculatedFor from "../Display/CostCalculatedFor";
import RecordNumber from "../Display/RecordNumber";


class PrincipalResultBondIndexedTable extends React.Component {

  state = {
    showPayments : false,
    showFuturePayments : false,
    showUnIndexed : false
  };

  constructor(props){
    super(props);
    this.showPaymentsClick = this.showPaymentsClick.bind(this);
    this.showFuturePaymentsClick = this.showFuturePaymentsClick.bind(this);
    this.showUnIndexedClick = this.showUnIndexedClick.bind(this);
  }

  showPaymentsClick(){
    this.setState({ showPayments: !this.state.showPayments });
  };

  showUnIndexedClick(){
    this.setState({ showUnIndexed: !this.state.showUnIndexed });
  };

  showFuturePaymentsClick(){
    this.setState({ showFuturePayments: !this.state.showFuturePayments });
  };






  render() {
    if (!this.props.data.legs){
      return (
        <div/>
      );
    }

    let principals = this.props.data.bond.legs[0].principals;

    let table1 = (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />         
          </colgroup>
          <thead>
          <tr>
            <th colSpan="17" className="text-left">
              <span className="calc-setting-table-header">Greiðslur.&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <input id="checkPrinciaplsid1" type="checkbox" checked={this.state.showPayments} onChange={this.showPaymentsClick}/><label className="calc-small-checkbox-label" htmlFor="checkPrinciaplsid1" >Sýna greiðsluflæði frá upphafi</label> &nbsp; &nbsp;
              <input id="checkPrinciaplsid2" type="checkbox" checked={this.state.showFuturePayments} onChange={this.showFuturePaymentsClick}/><label className="calc-small-checkbox-label" htmlFor="checkPrinciaplsid2" >Sýna framtíðar greiðslur</label> &nbsp; &nbsp;
              <input id="checkPrinciaplsid3" type="checkbox" checked={this.state.showUnIndexed} onChange={this.showUnIndexedClick}/><label className="calc-small-checkbox-label" htmlFor="checkPrinciaplsid3" >Sýna óverðtryggt</label>
            </th>
          </tr>
          <tr>
            <th className="text-left">G.nr.</th>
            <th className="text-left">Gjalddagi</th>
            <th className="text-right">Höf. í upph.</th>
            {this.state.showUnIndexed && <th className="text-right">&larr; Óvt.</th>}
            <th className="text-right">Afborgun</th>
            {this.state.showUnIndexed && <th className="text-right">&larr; Óvt.</th>}
            <th className="text-right">Vextir</th>
            {this.state.showUnIndexed && <th className="text-right">&larr; Óvt.</th>}
            <th className="text-right">Vaxta %</th>
            <th className="text-right">Heildargr.</th>
            <th className="text-right">Kostn.</th>
            <th className="text-right">Heildargr.+Kostn.</th>            
            <th className="text-right">Verðb. á afb.</th>
            <th className="text-right">Verðb. á hst.</th>
            <th className="text-right">Verðb. á v.</th>            
            <th className="text-right">Vísitala</th>        
            <th className="text-right">Dráttav.</th>      
         
          </tr>
          </thead>
          <tbody>
          {principals.map((item,i) => {
              if (!this.state.showFuturePayments && item.isFuturePayment) {
                return;
              }

              if (!this.state.showPayments && !item.isInsideBounds) {              
                return;
              }

              let cName = "row-current-normal";
              let isOdd = item.paymentNumber % 2 === 1;
              if (isOdd){
                cName = "row-current-highlight";
              }

              if (this.state.showPayments)  {
                cName = "row-incalc-normal";
                if (isOdd){
                  cName = "row-incalc-highlight";
                }                
              }

              if (!item.isDefaulted && !item.isFuturePayment){
                  cName = "row-past-normal";
                  if (isOdd){
                    cName = "row-past-highlight";
                  }
              }


              if (item.isFuturePayment){
                cName = "row-future-normal";
                if (isOdd){
                  cName = "row-future-highlight";
                }
              }       
            
        
            return([
                <tr key={i + "inner"} className={cName}>
                  <td className="text-left"><RecordNumber data={item.paymentNumber}/></td>                  
                  <td className="text-left"><Date data={item.dueDate}/></td>
                  <td className="text-right"><b><Amount data={item.capitalTotalAmount}/></b></td>
                  {this.state.showUnIndexed && <td className="text-right"><Amount data={item.capitalAmount}/></td>}
                  <td className="text-right"><b><Amount data={item.totalAmount}/></b></td>
                  {this.state.showUnIndexed && <td className="text-right"><Amount data={item.amount}/></td>}
                  <td className="text-right"><b><Amount data={item.interestTotalAmount}/></b></td>
                  {this.state.showUnIndexed && <td className="text-right"><Amount data={item.interestAmount}/></td>}
                  <td className="text-right"><Percentage data={item.interestRate}/></td>
                  <td className="text-right"><Amount data={item.totalPaymentAmount}/></td> 
                  <td className="text-right"><Amount data={item.costAmount}/></td>                 
                  <td className="text-right"><b><Amount data={item.totalPaymentAmount + item.costAmount}/></b></td>                 
                  <td className="text-right"><Amount data={item.indexOnAmount}/></td>
                  <td className="text-right"><Amount data={item.indexOnCapitalAmount}/></td>                                  
                  <td className="text-right"><Amount data={item.indexOnInterestAmount + item.equalizationAmount}/></td>                                  
                  <td className="text-right"><Amount data={item.indexPointFrom} precision={1}/>-<Amount data={item.indexPointTo} precision={1}/></td>                  
                  <td className="text-right"><Amount data={item.penaltyInterestAmount}/></td>                  
                                   

                </tr>]
            )
          })}
          </tbody>
        </table>
      </div>
    );

   
    
    return (
      <div>
        {table1}   
      </div>
    );
  }
}

PrincipalResultBondIndexedTable.propTypes = {
  data: PropTypes.object,
};



export default PrincipalResultBondIndexedTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Results/PrincipalResultBondIndexedTable.js